/**
 * returns true if the two objects are equal but not the same object. (compares the JSON equilient of each object).. should be faster.. should..
 * @param obj1
 * @param obj2
 */
export default function equivilentToByJSON(obj1, obj2) {
    return JSON.stringify(obj1) == JSON.stringify(obj2);
}
